import * as React from "react";
import Box from "@mui/material/Box";
import Informative from "../components/InformativeComponent";
import SignUpComponent from "../components/SignUpComponent";
import { Footer } from "../components/FooterComponent";

function SignIn() {
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: "black",
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "55% 45%",
            gridTemplateRows: "auto",
            gridTemplateAreas: `
                                "info   main"
                                "footer footer "`,
          }}
        >
          <Box sx={{ gridArea: "info", bgcolor: "error.main", color: "#fff" }}>
            <Informative crmMarginTop={"217px"} />
          </Box>
          <Box sx={{ gridArea: "main", bgcolor: "white" }}>
            <SignUpComponent />
          </Box>
          <Box sx={{ gridArea: "footer", bgcolor: "warning.dark" }}>
            <Footer />
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default SignIn;
